import { IconButton, Tooltip } from "@mui/material";
import useTheme from "@mui/material/styles/useTheme";
import { t } from "i18next";
import { LucideChevronDown } from "lucide-react";
import { type Dispatch, type SetStateAction } from "react";
import { DROPDOWN, type Dropdown } from "../Header.consts";

export function MenuIcon({
  showDropdownMenu,
  setAnchorElDropdown,
  setDropdown
} : {
  showDropdownMenu: boolean,
  setAnchorElDropdown: Dispatch<SetStateAction<HTMLElement | null>>
  setDropdown: Dispatch<SetStateAction<Dropdown | null>>
}) {
  const theme = useTheme();

  return (
    <Tooltip title={ t("open_settings") }>
      <IconButton
        aria-expanded={ showDropdownMenu }
        onClick={ (clickEvent) => {
          setAnchorElDropdown(clickEvent.currentTarget);
          showDropdownMenu && setDropdown(null);
          showDropdownMenu || setDropdown(DROPDOWN.MENU);
        } }
        sx={ {
          "&.Mui-focusVisible": {
            borderRadius: "2px",
            outline: `2px solid ${theme.customColors.headerIcon}`,
            outlineOffset: "2px"
          },
          ":hover": {
            background: "transparent"
          },
          color: theme.customColors.systemPrimary01,
          p: 0,
          transform: showDropdownMenu ? " rotate(180deg)" : " rotate(0deg)",
          transition: "transform .4s linear"

        } }
      >
        <LucideChevronDown
          aria-hidden="true"
          color={ theme.customColors.headerIcon }
          size={ 24 }
        />
      </IconButton>
    </Tooltip>
  );
}
